export default __webpack_public_path__ + "static/media/bg.9ca02857.jpg";